import { Database } from '@vuex-orm/core'

import Individual from '../modules/individual/models/Individual'
import individuals from '../modules/individual/models/individuals'
import Student from '../modules/student/models/Student'
import students from '../modules/student/models/students'
import Parent from '../modules/parent/models/Parent'
import parents from '../modules/parent/models/parents'
import Teacher from '../modules/teacher/models/Teacher'
import teachers from '../modules/teacher/models/teachers'
import Client from '../modules/client/models/Client'
import clients from '../modules/client/models/clients'
import YearLevel from '../modules/lesson/models/YearLevel'
import yearLevels from '../modules/lesson/models/yearLevels'
import Lesson from '../modules/lesson/models/Lesson'
import lessons from '../modules/lesson/models/lessons'
import Auth from '../modules/auth/models/Auth'
import auths from '../modules/auth/models/auths'
import Class from '../modules/class/models/Class'
import classes from '../modules/class/models/classes'
import Notification from '../modules/auth/models/Notification'
import notifications from '../modules/auth/models/notifications'
import ClassInvitation from '../modules/class/models/ClassInvitation'
import classInvitations from '../modules/class/models/classInvitations'
import Badge from '../modules/badge/models/Badge'
import badges from '../modules/badge/models/badges'
import Config from '../modules/config/models/Config'
import configs from '../modules/config/models/configs'

import User from '../modules/user/models/User'
import users from '../modules/user/models/users'

import UserLesson from '../modules/lesson/models/UserLesson'
import userLessons from '../modules/lesson/models/userLessons'

const database = new Database()

database.register(Individual, individuals)
database.register(Student, students)
database.register(Teacher, teachers)
database.register(Parent, parents)
database.register(Client, clients)
database.register(YearLevel, yearLevels)
database.register(Lesson, lessons)
database.register(Auth, auths)
database.register(Class, classes)
database.register(Notification, notifications)
database.register(ClassInvitation, classInvitations)
database.register(UserLesson, userLessons)
database.register(Badge, badges)
database.register(Config, configs)

database.register(User, users)

export default database
